(function () {
  "use strict";

  const TRANSITION_DURATION = 750;
  const TRANSITION_ID = "brand-page-transition";

  /* =========================================================
     CREATE TRANSITION
  ========================================================= */

  function createTransition() {
    if (document.getElementById(TRANSITION_ID)) {
      return document.getElementById(TRANSITION_ID);
    }

    const transition = document.createElement("div");

    transition.id = TRANSITION_ID;

    transition.innerHTML = `
      <div class="brand-transition-content">

        <img
          class="brand-transition-logo"
          src="https://cdn.shopify.com/s/files/1/1027/3669/1565/files/new_trans_logo.png?v=1789297402"
          alt="WOLFFOXX"
        >

        <div class="brand-transition-title">
          WOLFFOXX
        </div>

      </div>
    `;

    document.body.appendChild(transition);

    return transition;
  }


  /* =========================================================
     SHOW
  ========================================================= */

  function showTransition() {
    const transition = createTransition();

    transition.classList.remove("is-leaving");

    /*
     * Force browser reflow
     */
    void transition.offsetWidth;

    transition.classList.add("is-active");
  }


  /* =========================================================
     HIDE
  ========================================================= */

  function hideTransition() {
    const transition =
      document.getElementById(TRANSITION_ID);

    if (!transition) return;

    transition.classList.add("is-leaving");

    setTimeout(function () {
      transition.classList.remove("is-active");
      transition.classList.remove("is-leaving");
    }, 350);
  }


  /* =========================================================
     CHECK WHETHER LINK SHOULD USE TRANSITION
  ========================================================= */

  function shouldTransition(link, event) {

    if (!link) {
      return false;
    }

    if (!link.href) {
      return false;
    }

    /*
     * Modifier clicks
     */
    if (
      event.ctrlKey ||
      event.metaKey ||
      event.shiftKey ||
      event.altKey
    ) {
      return false;
    }

    /*
     * New tab
     */
    if (
      link.target === "_blank" ||
      link.target === "_parent" ||
      link.target === "_top"
    ) {
      return false;
    }

    /*
     * Download
     */
    if (link.hasAttribute("download")) {
      return false;
    }

    const url = new URL(
      link.href,
      window.location.href
    );

    /*
     * Only normal HTTP/HTTPS links
     */
    if (
      url.protocol !== "http:" &&
      url.protocol !== "https:"
    ) {
      return false;
    }

    /*
     * External websites
     */
    if (
      url.hostname !== window.location.hostname
    ) {
      return false;
    }

    /*
     * Same page
     */
    if (
      url.pathname === window.location.pathname &&
      url.search === window.location.search &&
      !url.hash
    ) {
      return false;
    }

    /*
     * Same-page anchor
     */
    if (
      url.pathname === window.location.pathname &&
      url.search === window.location.search &&
      url.hash
    ) {
      return false;
    }

    /*
     * CART AJAX ACTIONS
     */
    const path = url.pathname;

    if (
      path === "/cart/add" ||
      path === "/cart/update" ||
      path === "/cart/change" ||
      path === "/cart/clear"
    ) {
      return false;
    }

    /*
     * CHECKOUT
     */
    if (
      path === "/checkout" ||
      path.indexOf("/checkouts/") === 0
    ) {
      return false;
    }

    return true;
  }


  /* =========================================================
     MAIN CLICK HANDLER
     
     IMPORTANT:
     One handler for:
     - Header links
     - Header logo
     - Footer links
     - Footer logo
     - Product links
     - Collection links
     - Page links
  ========================================================= */

  document.addEventListener(
    "click",
    function (event) {

      /*
       * Find nearest <a>
       */
      const link =
        event.target.closest("a");

      if (!link) {
        return;
      }


      /*
       * Check transition
       */
      if (
        !shouldTransition(link, event)
      ) {
        return;
      }


      /*
       * Stop browser's normal navigation
       */
      event.preventDefault();


      /*
       * IMPORTANT:
       * Don't stopPropagation.
       * Shopify/Horizon can continue handling
       * its own components.
       */


      const destination = link.href;


      /*
       * SHOW WOLFFOXX ANIMATION
       */
      showTransition();


      /*
       * Navigate after animation
       */
      setTimeout(function () {

        window.location.href =
          destination;

      }, TRANSITION_DURATION);

    },
    true
  );


  /* =========================================================
     INITIALIZE
  ========================================================= */

  function initialize() {

    createTransition();

    /*
     * Hide any transition left from previous page
     */
    requestAnimationFrame(function () {

      setTimeout(function () {
        hideTransition();
      }, 100);

    });
  }


  /* =========================================================
     DOM READY
  ========================================================= */

  if (
    document.readyState === "loading"
  ) {

    document.addEventListener(
      "DOMContentLoaded",
      initialize
    );

  } else {

    initialize();

  }


  /* =========================================================
     BACK / FORWARD CACHE
  ========================================================= */

  window.addEventListener(
    "pageshow",
    function () {
      hideTransition();
    }
  );


})();